import { BaseUser, Role } from '@core/model/user.model';

export interface LoggedUser extends BaseUser {
  readonly fullName?: string;
  readonly role: LoggedUserRole;
}

export interface LoggedUserRole {
  name: Role;
  permissions: UserPermission[];
}

export interface UserPermission {
  readonly name: string;
}

export enum Permissions {
  // USER
  canManageQuestionnaire = 'canManageQuestionnaire',
  canManageDocuments = 'canManageDocuments',
  canManageTables = 'canManageTables',
  canManageProjects = 'canManageProjects',
  canManageUsers = 'canManageUsers',
  canManageSubscriptions = 'canManageSubscriptions',
  canManageEvent = 'canManageEvent',
  canManageSites = 'canManageSites',
  canViewSpecialist = 'canViewSpecialist',
  canViewCompanies = 'canViewCompanies',
  canManageWorkflowStatus = 'canManageWorkflowStatus',

  // ACCOUNTANT
  canManageCompanies = 'canManageCompanies',

  //BANK
  canViewSubscriptionsWithProgress = 'canViewSubscriptionsWithProgress',
  canViewSubscriptionsScore = 'canViewSubscriptionsScore',
  canDownloadQuestionnaire = 'canDownloadQuestionnaire',
  canDownloadBankDocuments = 'canDownloadBankDocuments',

  // DEFAULT
  canManageSelf = 'canManageSelf',
}
